import Button from './Button'
import ButtonLink from './ButtonLink'
export * from './Button.types'
export * from './ButtonLink.types'
export default Object.assign(Button, { Link: ButtonLink })
